<template>
  <div>
    <div class="gdlr-core-pbf-wrapper" id="div_1dd7_91">
      <div class="gdlr-core-pbf-background-wrap"></div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js">
        <div
          class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container"
        >
          <div
            class="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first"
          >
            <div class="gdlr-core-pbf-column-content-margin gdlr-core-js">
              <div
                class="gdlr-core-pbf-column-content clearfix gdlr-core-js"
                data-aos="zoom-in"
                data-aos-duration="3000"
                data-aos-delay="300"
              >
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-image-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                  >
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round"
                      id="div_1dd7_92"
                    >
                      <img
                        :src="
                          announcement &&
                          announcement[0] &&
                          announcement[0].image != null
                            ? announcement[0].image
                            : require('@/assets/images/template4/hp-donation-400x212.jpg')
                        "
                        width="700"
                        height="372"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr"
                  >
                    <router-link
                      :to="
                        `/pengumuman-detail/${announcement &&
                          announcement[0] &&
                          announcement[0].url}`
                      "
                      class="gdlr-core-title-item-title-wrap clearfix"
                    >
                      <h3
                        class="gdlr-core-title-item-title gdlr-core-skin-title"
                        id="h3_1dd7_31"
                      >
                        {{
                          announcement &&
                            announcement[0] &&
                            announcement[0].title
                        }}
                      </h3>
                    </router-link>
                    <span
                      class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                      id="span_1dd7_8"
                      v-html="
                        announcement && announcement[0] && announcement[0].body
                      "
                    >
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gdlr-core-pbf-column gdlr-core-column-20">
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js"
              id="div_1dd7_93"
            >
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-event-item gdlr-core-item-pdb"
                    id="div_1dd7_94"
                  >
                    <div
                      class="gdlr-core-block-item-title-wrap gdlr-core-left-align gdlr-core-item-mglr"
                      id="div_1dd7_95"
                    >
                      <div class="gdlr-core-block-item-title-inner clearfix">
                        <h3 class="gdlr-core-block-item-title" id="h3_1dd7_32">
                          Pengumuman
                        </h3>
                        <div
                          class="gdlr-core-block-item-title-divider"
                          id="div_1dd7_96"
                        ></div>
                      </div>
                    </div>
                    <div class="gdlr-core-event-item-holder clearfix">
                      <div
                        class="gdlr-core-event-item-list gdlr-core-style-widget gdlr-core-item-pdlr clearfix"
                        id="div_1dd7_97"
                        v-for="(announc, index) in announcement.slice(1, 4)"
                        :key="`annon_${index}`"
                        data-aos="fade-in"
                        :data-aos-duration="index + `000`"
                        :data-aos-delay="index + `00`"
                      >
                        <span
                          class="gdlr-core-event-item-info gdlr-core-type-start-date-month"
                        >
                          <span class="gdlr-core-date">{{
                            formattedDateDay(announc.published_at)
                          }}</span>
                          <span class="gdlr-core-month">{{
                            formattedDateMonth(announc.published_at)
                          }}</span>
                        </span>
                        <div class="gdlr-core-event-item-content-wrap">
                          <h3 class="gdlr-core-event-item-title">
                            <a :href="`/pengumuman-detail/${announc.url}`">{{
                              announc.title
                            }}</a>
                          </h3>
                          <div class="gdlr-core-event-item-info-wrap">
                            <span
                              class="gdlr-core-event-item-info gdlr-core-type-time"
                            >
                              <span class="gdlr-core-head">
                                <i class="icon_clock_alt"></i>
                              </span>
                              <span class="gdlr-core-tail">{{
                                formattedClock(announc.published_at)
                              }}</span>
                            </span>
                            <span
                              class="gdlr-core-event-item-info gdlr-core-type-location"
                            >
                              <span class="gdlr-core-head">
                                <i class="icon_pencil_alt"></i>
                              </span>
                              <span class="gdlr-core-tail">{{
                                announc.author
                              }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align"
                  >
                    <router-link
                      class="gdlr-core-button gdlr-core-button-transparent gdlr-core-button-no-border"
                      :to="`/pengumuman`"
                      id="a_1dd7_7"
                      ><span class="gdlr-core-content"
                        >Lihat Semua Pengumuman</span
                      ><i
                        class="gdlr-core-pos-right fa fa-long-arrow-right"
                        id="i_1dd7_2"
                      ></i
                    ></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="gdlr-core-pbf-column gdlr-core-column-20"
            data-skin="Newsletter"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js"
              id="div_1dd7_100"
            >
              <div class="gdlr-core-pbf-background-wrap">
                <div
                  class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"
                  id="div_1dd7_101"
                  data-parallax-speed="0"
                  :style="
                    'background-image: url(' +
                      require('@/assets/images/template4/link-bg.jpg') +
                      ')'
                  "
                ></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                <!-- <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-image-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align"
                    id="div_1dd7_102"
                  >
                    <div
                      class="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-rectangle"
                      id="div_1dd7_103"
                    >
                      <img
                        :src="
                          require('@/assets/images/template4/icon-envelope.png')
                        "
                        alt=""
                        width="78"
                        height="60"
                        title="icon-envelope"
                      />
                    </div>
                  </div>
                </div> -->
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-bottom gdlr-core-item-pdlr"
                    id="div_1dd7_104"
                  >
                    <div class="gdlr-core-title-item-title-wrap clearfix">
                      <h3
                        class="gdlr-core-title-item-title gdlr-core-skin-title"
                        id="h3_1dd7_33"
                      >
                        Tinggalkan Pesan
                      </h3>
                    </div>
                    <!-- <span
                      class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption"
                      id="span_1dd7_9"
                      >Get updates to news & events</span
                    > -->
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-newsletter-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-style-rectangle-full"
                  >
                    <div class="newsletter newsletter-subscription">
                      <form
                        class="gdlr-core-newsletter-form clearfix"
                        method="post"
                        action="#"
                      >
                        <div class="gdlr-core-newsletter-email">
                          <input
                            class="newsletter-email gdlr-core-skin-e-background gdlr-core-skin-e-content"
                            placeholder="Nama"
                            type="email"
                            name="ne"
                            size="30"
                            required
                          />
                        </div>
                        <div class="gdlr-core-newsletter-email">
                          <input
                            class="newsletter-email gdlr-core-skin-e-background gdlr-core-skin-e-content"
                            placeholder="Email"
                            type="email"
                            name="ne"
                            size="30"
                            required
                          />
                        </div>
                        <div class="gdlr-core-newsletter-email">
                          <input
                            class="newsletter-email gdlr-core-skin-e-background gdlr-core-skin-e-content"
                            placeholder="Pesan"
                            type="email"
                            name="ne"
                            size="30"
                            required
                          />
                        </div>
                        <div class="gdlr-core-newsletter-submit">
                          <input
                            class="newsletter-submit"
                            type="submit"
                            value="Kirim"
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "announcement",
  props: ["announcement"],

  methods: {
    formattedDate(date) {
      moment.locale("id");
      return moment(date).format("DD MMMM YYYY HH:MM");
    },
    formattedDateDay(date) {
      moment.locale("id");
      return moment(date).format("DD");
    },
    formattedDateMonth(date) {
      moment.locale("id");
      return moment(date).format("MMM");
    },
    formattedClock(date) {
      moment.locale("id");
      return moment(date).format("HH:MM");
    },
  },
};
</script>
